<template>
  <BaseListCard
    title="Contacts"
    :parentId="parentId"
    :parentTitle="parentTitle"
    :options="{ 'roles': roles,
                'rolesLoading': rolesLoading }"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :deleteEntity="deleteEntity"
    :deletePrompt="'Removing Contacts in TerraTrac does not delete Contacts in eTapestry. ' +
    'Are you sure you want to remove this Contact from this TerraTrac record?'"
    :deleteTitle="'Remove'"
    :deleteDisabled="deleteDisabled"
    :emptyEntity="emptyEntity"
    ref="baseCard"
    >
    <template v-slot:addForm="{ newEntity, options, stopAdding, entityCreated }">
      <ContactForm
        :initialContact="newEntity"
        :roles="options.roles"
        :rolesLoading="options.rolesLoading"
        :storeNamespace="storeNamespace"
        @closeForm="stopAdding"
        :parentType="parentType"
        :parentId="parentId"
      />
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <ContactForm
        :initialContact="entity"
        :roles="options.roles"
        :rolesLoading="options.rolesLoading"
        :storeNamespace="storeNamespace"
        :parentType="parentType"
        :parentId="parentId"
        @closeForm="stopEditing">
      </ContactForm>
    </template>
    <template v-slot:entityDetails="{ entity }">
      <div class="row contact-list-row">
        <div class="col-6 col-lg-3">
          <div class="list-header">Name</div>
          <div class="list-details">{{ entity.crmContact | contactName }}</div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="list-header">Address</div>
          <div class="list-details"
            v-html="$options.filters.contactAddress(entity.crmContact)">
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="list-header">Email</div>
          <a class="list-details" :href="`mailto:${entity.crmContact.email}`">
            {{ entity.crmContact.email ? entity.crmContact.email : 'None' }}
          </a>
        </div>
        <div class="col-6 col-lg-3">
          <div class="list-header">Role(s)</div>
          <div class="list-details">
            {{ rolesString(entity) }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="list-header">Role Details</div>
          <div class="list-details notes-field">{{ entity.notes || 'None' }}</div>
        </div>
      </div>
      <hr v-if="entity.crmContact.phones && entity.crmContact.phones.length > 0">
      <div class="row mb-2">
        <div class="col-6 col-lg-3"
          v-for='phone in entity.crmContact.phones'
          :key='phone.type'>
          <div class="list-header">{{ phone.type }}</div>
          <a class="list-details" :href="`tel:${phone.number}`">
            {{ phone.number }}
          </a>
        </div>
      </div>
    </template>
    <template v-slot:additionalActions="{ entity }">
      <router-link
      :to="{ name: 'contact', params: { id: entity.crmId } }"
      class="btn btn-secondary btn-sm mb-2 mr-2"
      >
        View
      </router-link>
    </template>
  </BaseListCard>
</template>

<script>
import { mapState } from 'vuex';
import BaseListCard from '../common/BaseListCard.vue';
import ContactForm from './ContactForm.vue';
import CollapseParent from '@/mixins/CollapseParent';
import { EntityModules } from '@/store/moduleConfig';

export default {
  name: 'ContactsCard',
  props: [
    'parentId',
    'parentType',
    'parentTitle',
    'roles',
    'rolesLoading',
    'entities',
    'entitiesLoading',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    ContactForm,
  },

  computed: {
    storeNamespace() {
      switch (this.parentType) {
        case 'instrument':
          return EntityModules.INSTRUMENT_CONTACT.namespace;
        case 'property':
          return EntityModules.PROPERTY_CONTACT.namespace;
        case 'service':
          return EntityModules.SERVICE_CONTACT.namespace;
        default:
          return null;
      }
    },
    ...mapState('User', {
      user: state => state.user,
    }),
  },
  methods: {
    // entitySort(a, b) {
    //   const lastNameCompare = (a.crmContact.lastName.localeCompare(b.crmContact.lastName));
    //   if (lastNameCompare === 0) {
    //     return (a.crmContact.firstName.localeCompare(b.crmContact.firstName));
    //   }
    //   return lastNameCompare;
    // },
    emptyEntity(parentId) {
      let instrumentId = null;
      let propertyId = null;
      let serviceId = null;
      switch (this.parentType) {
        case 'instrument':
          instrumentId = parentId;
          break;
        case 'property':
          propertyId = parentId;
          break;
        case 'service':
          serviceId = parentId;
          break;
        default:
          break;
      }
      return {
        roleIds: [],
        instrumentId,
        propertyId,
        serviceId,
      };
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${this.storeNamespace}/deleteEntity`, {
          entityType: 'contact',
          entity,
        },
      );
    },
    deleteDisabled(entity) {
      const contactHasRequestorRole = entity.roleIds.includes(39);

      return !this.user.idToken.roles.includes('Admin') && (contactHasRequestorRole);
    },
    capitalizeParentType() {
      return this.parentType.charAt(0).toUpperCase() + this.parentType.slice(1);
    },
    rolesString(entity) {
      return this.roles.filter(role => entity.roleIds.includes(role.id))
        .map(role => role.name)
        .join(', ');
    },
  },
};
</script>
